import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import domain from './domainDetector';

// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enMain from '../locales/en/main';
import enCategory from '../locales/en/category';
import enCategoryDetails from '../locales/en/categoryDetails';

import cnMain from '../locales/cn/main_CN.json';
import cnCategory from '../locales/cn/category_CN.json';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(domain);

const options = {
	order: ['querystring', 'domain'],
	lookupQuerystring: 'lng'
};

const getCurrentLanguage = () => {
	return i18n.language;
};

const resources = {
	en: {
		main: enMain,
		category: enCategory,
		categoryDetails: enCategoryDetails
	},
	cn: {
		main: cnMain,
		category: cnCategory,
		categoryDetails: enCategoryDetails
	}
};

i18n // .use(Backend)
	.use(languageDetector)
	.use(initReactI18next)
	.init({
		detection: options,
		resources,
		defaultNS: 'main',
		fallbackLng: 'en',
		debug: process.env.NODE_ENV !== 'production',
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		}
	});

export default i18n;
export { getCurrentLanguage };
